<template>
	<div :class="modalMode ? 'details-in-modal page-fill' : 'pt-3 px-5 pb-2 page-fill'">
        <div class="mb-2 ResponsiveStartAudit" v-if="!modalMode">
            <breadCrumbs :routesArray="routesArray"></breadCrumbs>
	    </div>
		<div class="items-center justify-between flex ResponsiveStartAudit">
			<div class="title flex items-center" v-if="!modalMode">
				<h1>{{presentAudit.title}}</h1>
			</div>
			<div v-else></div>
			<div class="flex items-center">
                <div class="flex parent-toggle-border border rounded-sm border-lightgrey bg-white">
                <button :class="{ 'active-tab': activeButton === 'myControls', 'inactive-tab': activeButton !== 'myControls' }" class="flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs" @click="showMyControls">
                    My Tasks
                </button>
                <button :class="{ 'active-tab': activeButton === 'allControls', 'inactive-tab': activeButton !== 'allControls' }" class="flex items-center font-semibold justify-center rounded p-px leading-3 cursor-pointer w-28 h-8 text-xs" @click="showAllControls">
                    All Tasks
                </button>
            </div>
            <!-- <button class="btnprimary ml-3 hidden items-center" @click="showAddControlPopup()">
                <img src="@/assets/plusIcon.svg" class="h-3 mr-2" />
                Add
            </button> -->
            <button class="filterButton ml-3 flex" @click="filterOpen" >
                <img src="@/assets/filter.svg" class="filterIcon" />
                Filters
            </button>
			</div>
		</div>
		<div class="mt-5 ResponsiveStartAudit">
			<p class="headerText">
				This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you
				to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security.
			</p>
		</div>
        <!-- {{sortedData}} -->
        <div class="mt-5 ResponsiveStartAudit table-section">
			<div class="table-data-root">
			<div class="table-card-shell tableCornerRadius bg-white">
			<div class="table-card-inner">
                <div class="table-container table-container-fit">
                    <div class="table-header-wrap">
                    <table class="table-fit-card table-header-table" :style="tableResizeStyle">
                        <colgroup>
                            <col v-for="column in columnNames" :key="'h-'+column" :style="columnStyle(column)" />
                        </colgroup>
                        <thead>
                            <tr class="table-header-row">
                            <th scope="col" v-for="column in columnNames" :key="column" class="bg-white th1 cursor-pointer capitalize resizable-th" :class="getColumnHeadWidth(column)" :style="columnStyle(column)" @click="onHeaderClick(column)" @mouseout="doFalse()">
                                <div class="flex table-header-label-wrap" :class="getPaddingForColumn(column)">
                                    <div class="table-header-label" @mousemove="headerToolTip(column, $event)">
                                    <div v-if="column == 'auditStatus'">
                                        <div>{{ 'Status' }}</div>
                                    </div>
                                    <div v-else-if="column == 'controlNumber'" >
                                        <div>{{ 'Control ' }}</div>
                                    </div>
                                    <div v-else-if="column == 'taskId'" >
                                        <div>{{ 'ID' }}</div>
                                    </div>
                                    <div v-else-if="column == 'controlName'">
                                        <div>{{ 'Title' }}</div>
                                    </div>
                                     <div v-else-if="column == 'dueDate'">
                                        <div>{{ 'Due Date' }}</div>
                                    </div>
                                    <div class="pl-5" v-else-if="isColumnFrameWork(column)">{{column}}</div>
                                    <div v-else>{{ column }}</div>
                                    </div>
                                    <div v-if="!isColumnFrameWork(column)" class="sort cursor-pointer" :class="className == column ? classSort : 'opacity-50'"></div>
                                </div>
                                <span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, column)"></span>
                                <div v-if="pop == true && tipColumn == column && tipIndex == 'header'">
                                    <tool-tip :columnName="column" :tipText="tipText" :styling="styling"></tool-tip>
                                </div>
                            </th>
                            </tr>
                            <tr v-if="showFilters" class="table-filter-row">
                                <td v-for="name in columnNames" class="bg-white" :key="name" :class="getColumnHeadWidth(name)" :style="columnStyle(name)">
                                    <div v-if="isColumnFrameWork(name)"></div>
                                    <select v-else-if="name == 'auditStatus'" class="inputboxstylingForSelect mx-auto filterwidth" v-model="filterDummy[name]" :class="filterDummy[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'">
                                        <option :value="filterDummy.name" selected hidden disabled>Select</option>
                                        <option class="optionColors" v-for="option in auditStatusCodes" :key="option.id" :value="option.id">{{ option.value }}</option>
                                    </select>
                                    <div v-else-if=" name == 'dueDate'"></div>
                                    <input v-else-if="name == 'controlNumber'" type="text" class="inputboxstylingForControlID" placeholder="Search" v-model.trim="filterDummy[name]" />
                                    <input v-else type="text" class="searchForInputBoxStyling" placeholder="Search" v-model.trim="filterDummy[name]" />
                                </td>
                            </tr>
                        </thead>
                    </table>
                    </div>
                    <div class="table-body-scroll">
                    <table class="table-fit-card" :style="tableResizeStyle">
                        <colgroup>
                            <col v-for="column in columnNames" :key="'b-'+column" :style="columnStyle(column)" />
                        </colgroup>
                        <tbody v-if="dataLoading == true">
                            <tr class="cursor-pointer empty rowHeight">
                                <td class="relative h-5" :colspan="columnNames.size">
                                    <div class="flex items-center justify-center w-full h-16 skeleton">
                                        <dots-loader/>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody class="empty" v-else-if="sortedData.length == 0">
                            <tr class="cursor-pointer rowHeight">
                                <td class="relative h-10" :colspan="columnNames.size">
                                    <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                                </td>
                            </tr>
                        </tbody>

                        <tbody class="nonEmptyTable" v-else>
                            
                            <tr v-for="(row, index) in sortedData" :key="index" class="rowHeight" @click="goToControlTaskEdit(row._id)">
                                <td v-for="presentColumn in columnNames" :key="presentColumn" @mouseout="doFalse()" class="cursor-pointer relative" :class="getColumnHeadWidth(presentColumn)" :style="columnStyle(presentColumn)">
                                    <div class="h-full w-full flex items-center" v-if="isColumnFrameWork(presentColumn)">
                                        <div class="h-full w-full flex flex-wrap items-center" v-if="row[presentColumn].length>0" >
                                            <div v-for="ctrlNumber in row[presentColumn]" @click="clickedOnFrameWorkControlNumber(ctrlNumber,presentColumn)" :key="ctrlNumber" :class="getBorder()" class="text-xs m-2 px-2 py-0.5 font-opensans bg-white font-bold h-auto flex items-center" >
                                                {{ctrlNumber}}
                                            </div>
                                        </div>
                                        <div class="pl-4" v-else>
                                            {{'N/A'}}
                                        </div>
                                    </div>
                                    <!-- <div v-else-if="presentColumn == 'team'"><p class="cursor-pointer text-xs">{{ getTeamName(row[presentColumn]) }}</p></div> -->
                                    <!-- <div v-else-if="presentColumn == 'entity'"><p class="cursor-pointer text-xs">{{ getLocationName(row[presentColumn]) }}</p></div> -->
                                    <div v-else-if="presentColumn == 'auditStatus'" class="flex justify-center">
                                        <div class="flex items-center justify-center rounded h-5 w-32" :class="colorAuditBg(row.auditStatus)">
                                        <div :class="colorAuditText(row.auditStatus)">
                                            {{
                                                (auditStatusCodes.find((l) => {
                                                    return l.id == row[presentColumn];
                                                }) || {}).value || '-'
                                            }}
                                        </div>
                                    </div>
                                    </div>
                                    <div v-else-if="presentColumn =='dueDate'" 
                                        class="flex items-center justify-center w-20 rounded h-5 mx-auto"
                                         :class="shouldStyleDueDate(row) ? colorForDueDate(row[presentColumn]) : ''">
                                        {{ row[presentColumn] }} 
                                    </div>
                                    <div v-else>
                                        <div class="table-ellipsis" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
                                                {{ row[presentColumn] }}
                                        </div>
                                        <div v-if="pop == true && tipColumn == presentColumn && tipIndex == index">
                                            <tool-tip :columnName="presentColumn" :tipText="tipText" :styling="styling"></tool-tip>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData"></pagination>
            </div>
            </div>
            </div>
		</div>

        <popup v-if="addControlPopup" :popUp="addControlPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>New Control</h1>

                    <button class="float-right text-3xl" @click="onCloseAddPopup()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>

            <div class="popup-business">
                <div>
                    <div>
                        <div class="statuscontainer popupbodycontainer">
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Control Number</label><br />
                                        <input class="inputboxstyling" placeholder="Control Number" :value="controlAddObject.controlNumber" />
                                    </div>
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Title</label><br />
                                        <input class="inputboxstyling" placeholder="Title" :value="controlAddObject.controlTitle" />
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Team</label><br />
                                        <select
                                            class="inputboxstyling"
                                            v-model="controlAddObject.team"
                                        >
                                            <option value='' selected disabled hidden>Please select one</option>

                                            <option v-for="option in teamObject" :key="option" :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="w-1/2 px-2">
                                        <label for="number" class="controllabel">Location</label><br />
                                        <select
                                            class="inputboxstyling"
                                            v-model="controlAddObject.entity"
                                        >
                                            <option value='' selected disabled hidden>Please select one</option>

                                            <option v-for="option in locationObject" :key="option" :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </popup>

        <popup v-if="viewControlNumberPopup" :popUp="viewControlNumberPopup">
            <template v-slot:header>
                <div class="flex items-center justify-between popupheadingcontainer rounded">
                    <h1>{{frameWorkControlNumberObject.selectedFrameWork}}</h1>

                    <button class="float-right text-3xl" @click="onCloseFrameWorkControl()">
                        <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
                    </button>
                </div>
            </template>

            <div class="popup-business">
                <div>
                    <div>
                        <div class="statuscontainer popupbodycontainer">
                            <div class="formcontainer flex flex-col">
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-full px-1">
                                        <label for="number" class="controllabel">Frame Work No:</label><br />
                                        <div class="inputboxstyling">{{frameWorkControlNumberObject.controlNumber}}</div>
                                        <!-- <input class="inputboxstyling" placeholder="Frame Work Number" :value="frameWorkControlNumberObject.controlNumber" /> -->
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-full px-1">
                                        <label for="number" class="controllabel">Title</label><br />
                                        <div class="inputboxstyling">{{frameWorkControlNumberObject.controlTitle}}</div>
                                        <!-- <input class="inputboxstyling" placeholder="Title" :value="frameWorkControlNumberObject.controlTitle" /> -->
                                    </div>
                                </div>
                                <div class="row flex flex-row w-full mt-3">
                                    <div class="w-full px-1">
                                        <label for="number" class="controllabel">Description</label><br />
                                        <!-- <textarea class="inputboxstyling" placeholder="Threat" v-model="frameWorkControlNumberObject.description"/> -->
                                        <div class="inputboxstyling">{{frameWorkControlNumberObject.description}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </popup>
	</div>
</template>
<style scoped>
/* table {
  table-layout: fixed;
  width: 100%;
} */
 .table-container {
  width: 100%;
  overflow: hidden;
}
.widthForDueDate{
    width:100px;
}
.bgdarkred{
 background-color: rgba(192, 0, 0, 0.2);
}
table {
  table-layout: fixed;
}
th, td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  text-align: left;
  vertical-align: middle;
}
.inputboxstylingForSelect .optionColors{
   color : #4D4D4D !important;
}
.popup-business {
    overflow-y: scroll;
}
::-webkit-scrollbar {
    width: 0px;
}
.nonEmptyTable:last-child  {
	border-bottom: 1px solid #e9e9e9;
}
.rowHeight {
	height: 60px;
}
.numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #152A43;
    border-width: 2px;
}
.active-tab {
    background-color: #1976d2;
    color: white;
}
.active-tab, .inactive-tab {
    transition: background-color 0.4s ease, color 0.4s ease;
}
.inactive-tab {
    color: black;
    fill: #1976d2 !important;
}
.table-ellipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
	overflow-wrap: normal;
	max-width: 100%;
}
.pendingEvidence{
    background-color: #8600f040;
}
.pendingEvidenceFill{
    background-color: #8600F0;
}
.textColorWhite {
    color: #ffffff;
}
.evidenceUpload{
    background: rgba(25,118,210,0.24);
}
.filterwidth{
    width : 132px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required } from '@vuelidate/validators';
import tableData from '@/components/tableData.vue';
import { mapGetters } from 'vuex';
import { emitter, toast } from '@/main';
import { groupBy } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import pagination from '@/components/pagination.vue';
import popup from '@/components/popup.vue';
import toolTip from '@/components/toolTip.vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import dotsLoader from '@/components/dotsLoader.vue';
import moment from 'moment';
import { columnResizeMixin } from '@/mixins/columnResizeMixin';

export default defineComponent({
	mixins: [columnResizeMixin],
	data(): any {
		return {
			showFilters: false,
            visibility: false,
            allFrameWorkControls:[],
            filters: {},
            orgFrameWorks:[],
            presentAuditFrameWorks:[],
            tableRow:[],
            mainHeaders:[],
            filterDummy: {},
			classSort: '',
			className: '',
			dummyList:[],

			pageType: '',

			currentSort: 'name',
			currentSortDir: 'asc',

			currentPage: '',
			pageSize:'',
			dynamicPagination: '',
            teamObject:[],
            teamsData:[],
            locationObject:[],
            pop: false,
			styling: { left: '', bottom: '' },
			tipText: '',
			tipColumn: '',
			tipIndex: '',
            activeButton:'',
            addControlPopup:false,
            controlAddObject:{
                controlNumber:'',
                controlTitle:'',
                team:'',
                entity:'',
            },
            viewControlNumberPopup:false,
            frameWorkControlNumberObject:{},
            auditStatusCodes: [],
            startAuditTitle:[],
            routesArray: [],
            presentAudit:{},
            internalControlsDetailsArray:[],
            mainAuditControls:[],
            tasksForAudit:[],
            dataLoading:true
		};
	},
	components: {
        pagination,
        popup,
        toolTip,
        breadCrumbs,
        dotsLoader
	},
	props: {
		auditId: { type: [String, Number], default: null },
		tasks: { type: [String, Number], default: null },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['header-info', 'open-nested'],
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
		currentAuditId(): any {
			return this.auditId || this.$route.params.auditId;
		},
        sortedData: function (): any {
			return [...this.tableRow]
				.filter((row: any, index: any) => {
					for (const key in this.filterDummy) {
						const inputValue = this.filterDummy[key];
						if (inputValue !== '' && row[key]) {
							if (Number.isInteger(row[key])) {
								if (row[key] !== Number(inputValue)) {
									return false;
								}
							} else {
								if (!row[key].toLowerCase().includes(inputValue.toLowerCase())) {
									return false;
								}
							}
						}
					}
					return true;
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir === 'desc') modifier = -1;
					if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
					if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
        columnNames: function (): any {
			const names = new Set();
			for (const key of this.mainHeaders) {
				names.add(key);
			}
			return names;
		}
	},
	// async mounted() {
	// },
	methods: {
		getResizeColumnNames(): string[] {
			return Array.from(this.columnNames || []);
		},
        getColumnname(column:any){
            column='Status'
            return column
        },
        async getAuditTaskStatuses(){
            let appId='10006';
            let entityId='10118';
            await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {
                this.auditStatusCodes = (result.data.statuses || []).map((item: any) => ({
                    id: item.id,
                    value: item.label
                }));
            });
        },
        colorAuditText(status: any) {
			if (status == 10401) {
				return ['font-semibold text-disabledgrey'];
			} else if (status == 10402 || status==10421) {
				return ['font-semibold text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-lightgreen'];
			} else if(status == 10414|| status == 10415){
				return ['font-semibold text-electricGreen']
			} else if(status == 10416){
				return ['font-semibold mx-2 text-primary']
			}else if(status == 10417 || status == 10418){
				return ['font-semibold mx-2 text-darkred']
			}
		},
		colorAuditBg(status: any) {
			if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10402|| status==10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10414 || status == 10415) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10416) {
				return ['evidenceUpload border-solid border border-primary'];
			}else if (status == 10417 || status == 10418) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			}
		},
        colorForDueDate(date: any) {
		if (!date) return '';

		const [day, month, year] = date.split('-').map(Number);
		const due = new Date(year, month - 1, day);
		if (isNaN(due.getTime())) return '';

		const today = new Date();
		due.setHours(0, 0, 0, 0);
		today.setHours(0, 0, 0, 0);
		if (due < today) {
			return "bgdarkred border-solid border text-darkred font-semibold flex justify-center items-center text-xs";
		}
		return '';
	},
        shouldStyleDueDate(row:any) {            
            const status = row.auditStatus ?? row.auditStatus;
            return status != 10403 && status != 10418;
        },
        getColumnHeadWidth(column: any) {
            if (column == 'controlName') {
                return 'titleColumnWidth';
            } else if (column == 'auditStatus') {
                return 'statusColumnWidth';
            } else if (column == 'entity' ) {
                return 'w-36';
            }else if (column == 'dueDate') {
                return 'widthForDueDate';
            } else if( column == 'controlNumber'|| column=='location'){
                return 'w-36';
            }
            else if(column == 'CID'|| column == 'team' || column == 'taskId'){
                return 'w-24'
            }
            else {
                return '';
            }
        },
        getPaddingForColumn(column:any){
            if(column == 'auditStatus'){
                return 'justify-center items-center'
            }else if(column=='dueDate'){
                return 'justify-center items-center'
            }else{
                return ''
            }
        },
        isColumnFrameWork(presentColumn:any){
            if(this.presentAuditFrameWorks.includes(presentColumn)){
                return true
            }else{
                return false
            }
        },
        goToControlTaskEdit(taskId:any){
            if (this.modalMode) {
                this.$emit('open-nested', {
                    view: 'controlEdit',
                    title: 'Task',
                    params: { auditId: this.currentAuditId, taskId: taskId },
                });
            } else {
                emitter.emit('openDetailsModal', {
                    view: 'controlEdit',
                    title: 'Task',
                    params: { auditId: this.currentAuditId, taskId: taskId },
                });
            }
        },
        clickedOnFrameWorkControlNumber(ctrlNum:any,frameWork:any){
            let findObj:any = this.allFrameWorkControls.find((obj:any)=>{return obj.controlNumber == ctrlNum && obj.controlFrameWork ==  frameWork})
            this.frameWorkControlNumberObject.selectedFrameWork = frameWork;
            this.frameWorkControlNumberObject.controlNumber = ctrlNum;
            if(findObj!= undefined){
                this.frameWorkControlNumberObject.controlTitle = findObj.controlTitle;
                this.frameWorkControlNumberObject.description = findObj.controlAuditMethodology
            }
            this.viewControlNumberPopup = true;
        },
        onCloseFrameWorkControl(){
            this.viewControlNumberPopup = false;
        },
        showAddControlPopup(){
            this.addControlPopup = true
        },
        onCloseAddPopup(){
            this.addControlPopup = false
            Object.keys(this.controlAddObject).forEach((prop) => {
				Array.isArray(this.controlAddObject[prop]) ? (this.controlAddObject[prop] = []) : (this.controlAddObject[prop] = '');				
			});
        },
        showMyControls(){
            this.activeButton = 'myControls'
        },
        showAllControls(){
            this.activeButton = 'allControls'
        },
        getBorder(){
            return `numberBorder numberNavy`
        },
        toolTip(column: any, e: any, index: any, row: any, status: any) {
			this.tipText = (e.currentTarget?.textContent || row[column] || '').toString().trim();
			this.tipColumn = column;
			this.tipIndex = index;

			switch (status) {
				case 'text':
					this.handleTextTooltip(e);
					break;
			}
		},
		headerToolTip(column: any, e: any) {
			const container = e.currentTarget;
			const label = (container?.textContent || '').toString().trim();
			if (label && container && this.isTextOverflowed(container)) {
				this.pop = true;
				this.tipText = label;
				this.tipColumn = column;
				this.tipIndex = 'header';
				this.styling.left = e.offsetX + 38 + 'px';
				this.styling.bottom = -15 + 'px';
			} else {
				this.pop = false;
			}
		},
		handleTextTooltip(e: any) {
			const container = e.currentTarget.classList?.contains('table-ellipsis')
				? e.currentTarget
				: e.currentTarget.closest('.table-ellipsis');
			if (container && this.isTextOverflowed(container)) {
				this.pop = true;
				this.styling.left = e.offsetX + 38 + 'px';
				this.styling.bottom = -15 + 'px';
			} else {
				this.pop = false;
			}
		},
		isTextOverflowed(element: any) {
			return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
		},
		doFalse() {
			this.pop = false;
		},
        sort(tableHead: any) {
			this.className = tableHead;
			if (tableHead == this.currentSort) {
				this.currentSortDir = this.currentSortDir == 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = tableHead;
			this.classSort = this.currentSortDir == 'asc' ? 'sort_asc' : 'sort_desc';
		},
		paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
		filterOpen() {
			this.showFilters = !this.showFilters;
			emitter.emit('visible', this.showFilters);
            this.filterDummy = {}
		},
        getTeamName(ownerId: any) {
            let user = this.teamObject.find((obj: any) => {
                return obj.value == ownerId;
            });
            
            if (user == undefined) {
                let empty = '';
                return empty;
            } else {
                return user.label;
            }
        },
		 getLocationName(locationId: any) {
            let locationObj = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
            if (locationObj == undefined) {
                let empty = 'N/A';
                return empty;
            } else {
                return locationObj.label;
            }
        },
        async getAllControls(){
            await this.$http
				.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`)
				.then((result: { data: any }) => {
                    let controls:any = result.data;
                    this.allFrameWorkControls = result.data;
				})
				.catch((error: any) => {
                    toast.error(` ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
				});
        },
        async getAllTeams() {
            this.teamObject = []
            let users:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                users = res.data;
                this.teamsData = res.data;
            });
            for (var i = 0; i < users.length; i++) {
                this.teamObject.push({ label: users[i].displayName, value: users[i]._id });
            }
        },
		 async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id ,entityType:result[i].entityType});
            }
        },
        async getPresentAudit(){
			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audits/getAll`).then((result: any) => {
				// this.existingAuditsArray = [...result.data];
                this.presentAudit = result.data.find((obj:any)=>{
                   return  obj._id == this.currentAuditId;
                })
               this.presentAuditFrameWorks =  [...this.presentAudit.frameworks]
               if (this.modalMode && this.presentAudit?.title) {
                    this.$emit('header-info', { title: this.presentAudit.title });
               }
			})
		},
        async startSelectedAuditTasks(cameId:any){
            if(this.presentAudit.statusCode == 10401){
                try{
                    await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${cameId}/start`).then(async (result: any) => {
                        // console.log('Audit started')
                    })
                }catch{
                    toast.error(`Start Failed`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
                }
            }
            if(!Object.keys(this.presentAudit).includes('tasks')){
                await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${cameId}/startAudit`).then(async (result: any) => {
                    this.internalControlsDetailsArray = [...result.data];

                    let workflowPayload:any = [];
                    this.internalControlsDetailsArray.map((obj:any,index:any)=>{
                        const control_ids = obj.controls.map((control:any) => control._id);
                        let object:any = {
                            'auditId':cameId,
                            'controls': control_ids,
                            'department': obj.departmentsAndEntities[0].department,
                            'createdAt': new Date(),
                            'createdBy': this.userInfo._id
                        }
                        workflowPayload.push(object);
                    })

                    //inititae the work flow api for task creation
                    if( !Object.keys(this.presentAudit).includes('tasks') && this.internalControlsDetailsArray.length > 0){
                        await this.createWorkFlowTasksForAudit(workflowPayload)
                    }
                })
            }
			
		},
        async createWorkFlowTasksForAudit(payload:any){
            try{
                 await this.$http.post(`${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_AUDIT_WORKFLOW_ID}/audit/task`, payload).then((result: any) => {
                //    console.log('task created')
                });
            }catch{
                toast.error(`Task Creation Failed`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },
        async getTasksForAudit(id:any){
            this.tasksForAudit = []
            try{
                 await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${id}/tasks/get`).then((result: any) => {
                   this.tasksForAudit = result.data;
                });
            }catch{
                toast.error(`error`, {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }
        },

        async getDetailsForTable(){

            this.tableRow = []
            this.tasksForAudit.map((taskObj:any)=>{
                let presentLocation:any
                
                let presentteamObject:any = this.teamsData.find((obj: any) => {
                    return obj._id == taskObj.department;
                });

                if (presentteamObject != undefined && presentteamObject.entityType == 20301){
                    presentLocation = this.locationObject.find((l:any)=>l.entityType==1)?.label|| 'N/A';
                }else if(presentteamObject != undefined && presentteamObject.entityType == 20303){
                    presentLocation = presentteamObject.entityDisplayName
                }

                let sendObject:any = { 
                        "_id": taskObj._id , 
                        "taskId": taskObj.taskId  != undefined ? taskObj.taskId : 'N/A',
                        "CID": taskObj.clientUniqueId != undefined ? taskObj.clientUniqueId : 'N/A',
                        "controlName": taskObj.controlTitle != undefined ? taskObj.controlTitle : 'N/A', 
                        "team": presentteamObject?.displayName  != undefined ? presentteamObject.displayName : 'N/A',
                        "location": presentLocation != undefined ? presentLocation : 'N/A',
                        "dueDate":taskObj.dueDate!=undefined?moment(taskObj.dueDate).format('DD-MM-YYYY'):'N/A',
                        "auditStatus": taskObj.statusCode != undefined ? taskObj.statusCode : 'N/A',
                    };

                this.tableRow.push(sendObject)
            })
            
        },
        async onDetailsModalClosed(payload: any) {
            if (payload?.view && payload.view !== 'controlEdit') {
                return;
            }
            const scrollEl = this.$el?.querySelector?.('.table-body-scroll') as HTMLElement | null;
            const scrollTop = scrollEl?.scrollTop || 0;
            this.dataLoading = true;
            this.tableRow = [];
            const auditId = this.presentAudit?._id || this.currentAuditId;
            await this.getTasksForAudit(auditId);
            await this.getDetailsForTable();
            this.dataLoading = false;
            await this.$nextTick();
            const restored = this.$el?.querySelector?.('.table-body-scroll') as HTMLElement | null;
            if (restored) {
                restored.scrollTop = scrollTop;
            }
        },
	},

	async created() {
        this.dataLoading = true;

        let headersData = ['taskId','CID','controlName','team','location','dueDate','auditStatus']

        this.mainHeaders = headersData;

        await this.getAuditTaskStatuses();
        await this.getPresentAudit();
        
        await this.startSelectedAuditTasks(this.currentAuditId)
        
        this.showMyControls();
        await this.getAllTeams();
        await this.getallEntities();
        await this.getAllControls()
       

        await this.getTasksForAudit(this.presentAudit._id)

        this.routesArray = [
            { name: 'Audit', routeName: 'audit' },
             { name: this.presentAudit.title , routeName: 'view-audit' },
            { name: 'Tasks' , routeName: 'start-audit' },
        ];

        await this.getDetailsForTable();

        this.dataLoading = false;

        const taskFilter = this.tasks || this.$route.query.tasks;
        if(taskFilter){
            this.showFilters = true;
            this.filterDummy.auditStatus = taskFilter;
        }
    },
    
    async mounted(){
        emitter.off('detailsModalClosed', this.onDetailsModalClosed);
        emitter.on('detailsModalClosed', this.onDetailsModalClosed);
        emitter.on('visible', (isBoolean: any) => {
			this.visibility = isBoolean;
			this.visibility == false ? this.filters = {}:'';
		});
       
    },
    beforeUnmount() {
        emitter.off('detailsModalClosed', this.onDetailsModalClosed);
    }
});
</script>
